import { Box, Button, Card, Checkbox, Container, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Step, StepContent, StepLabel, Stepper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify'
import { getData, patchData } from 'src/webService/webService';

function ViewDetails() {

    const { id } = useParams();
    const [activeStep, setActiveStep] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [users, setUsers] = useState([]);
    const [serviceData, setServiceData] = useState({});
    const [action, setAction] = useState('View');
    const [history, setHistory] = useState([]);

    const reversedHistory = history.reverse();

    const [formData, setFormData] = useState({
        generalStatus: "Converted",
        serviceName: [],
        startDate: "",
        duration: "",
        callHistory: "",
        requirements: "",
        assignedUser: "",
        assignedTo: [],
        serviceStatus: "",
        progress: ""
    });
    const sessionToken = sessionStorage.getItem("Token");

    const serviceOptions = [
        "Video Editing",
        "WebSite Designing",
        "SEO",
        "Social Media",
        "Graphic Designing",
        "Content Creation",
        "Camera Man"
    ];

    const getAllUsers = useCallback(async () => {
        try {
            const params = { page: 1, limit: 1000 };
            const response = await getData("users/users", params, sessionToken);

            const filteredUsers = response.data.results.filter(
                user => user.role === "Service" && user.roleType === "Team Leader"
            );

            setUsers(filteredUsers);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    }, [sessionToken]);

    useEffect(() => {
        const fetchLeadDetails = async () => {
            debugger
            try {
                const response = await getData(`leads/lead/${id}`, {}, sessionToken);
                if (response?.status === 200) {
                    const leadData = response.data;
                    setHistory(response?.data?.assignedToHistory || []);

                    const initialFormData = {
                        generalStatus: leadData.generalStatus || "Converted",
                        name: leadData.name || "",
                        email: leadData.email || "",
                        phone: leadData.phone || "",
                        location: leadData.location || "",
                        company: leadData.company || "",
                        source: leadData.source || "",
                        summary: leadData.summary || "",
                        assignedTo: leadData.assignedTo || [],
                        callHistory: leadData.callHistory || [],
                        paymentHistory: leadData.paymentHistory || []
                    };
                    setFormData(initialFormData);

                    // Handle website designing history if exists
                    if (leadData.websiteDesigningHistory && leadData.websiteDesigningHistory.length > 0) {
                        const latestWebsiteDesign = leadData.websiteDesigningHistory[leadData.websiteDesigningHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            websiteId: latestWebsiteDesign._id,
                            websiteType: latestWebsiteDesign.websiteType || "",
                            totalPages: latestWebsiteDesign.totalPages || 0,
                            completedPages: latestWebsiteDesign.completedPages || 0,
                            requirements: latestWebsiteDesign.requirements || "",
                            deadline: latestWebsiteDesign.deadline || "",
                            amount: latestWebsiteDesign.amount || 0,
                            paymentStatus: latestWebsiteDesign.paymentStatus || "",
                            comments: latestWebsiteDesign.comments || "",
                            websiteSchema: latestWebsiteDesign.websiteSchema || [],
                            hostingProvider: latestWebsiteDesign.hostingProvider || "",
                            domainProvider: latestWebsiteDesign.domainProvider || "",
                            hostingRenewalDate: latestWebsiteDesign.hostingRenewalDate || "",
                            domainRenewalDate: latestWebsiteDesign.domainRenewalDate || "",
                            domainCost: latestWebsiteDesign.domainCost || "",
                            hostingCost: latestWebsiteDesign.hostingCost || "",
                        }));
                    }

                    // Handle social media history if exists
                    if (leadData.socialMediaHistory && leadData.socialMediaHistory.length > 0) {
                        const latestSocialMedia = leadData.socialMediaHistory[leadData.socialMediaHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            socialMediaId: latestSocialMedia._id,
                            platform: latestSocialMedia.platform || [],
                            postType: latestSocialMedia.postType || [],
                            contentTopic: latestSocialMedia.contentTopic || "",
                            postCaption: latestSocialMedia.postCaption || "",
                            hashtagsUsed: latestSocialMedia.hashtagsUsed || [],
                            scheduledDateTime: latestSocialMedia.scheduledDateTime || "",
                            postStatus: latestSocialMedia.postStatus || "",
                            totalPosts: latestSocialMedia.totalPosts || 0,
                            monthlyPosts: latestSocialMedia.monthlyPosts || 0,
                            completedPosts: latestSocialMedia.completedPosts || 0,
                            socialMediaComments: latestSocialMedia.comments || ""
                        }));
                    }

                    // Handle SEO history if exists
                    if (leadData.seoHistory && leadData.seoHistory.length > 0) {
                        const latestSEO = leadData.seoHistory[leadData.seoHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            seoId: latestSEO._id,
                            seoType: latestSEO.seoType || [],
                            seoPackageType: latestSEO.seoPackageType || "",
                            targetKeywords: latestSEO.targetKeywords || [],
                            keywordRanking: latestSEO.keywordRanking || "",
                            backlinkStatus: latestSEO.backlinkStatus || "",
                            targetLocation: latestSEO.targetLocation || [],
                            seoComments: latestSEO.comments || ""
                        }));
                    }

                    if (leadData.contentCreationHistory?.length > 0) {
                        const latestContentCreation = leadData.contentCreationHistory[leadData.contentCreationHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            contentCreationId: latestContentCreation._id,
                            contentType: latestContentCreation.contentType || "",
                            contentTopic: latestContentCreation.contentTopic || "",
                            wordCount: latestContentCreation.wordCount || 0,
                            deadline: latestContentCreation.deadline || "",
                            contentRequirements: latestContentCreation.requirements || "",
                            contentComments: latestContentCreation.comments || ""
                        }));
                    }

                    if (leadData.cameraHistory?.length > 0) {
                        const latestCamera = leadData.cameraHistory[leadData.cameraHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            cameraId: latestCamera._id,
                            shootType: latestCamera.shootType || "",
                            shootLocation: latestCamera.shootLocation || "",
                            shootDate: latestCamera.shootDate || "",
                            duration: latestCamera.duration || "",
                            cameraRequirements: latestCamera.requirements || "",
                            cameraComments: latestCamera.comments || ""
                        }));
                    }

                    if (leadData.videoEditingHistory?.length > 0) {
                        const latestVideoEditing = leadData.videoEditingHistory[leadData.videoEditingHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            videoEditingId: latestVideoEditing._id,
                            videoType: latestVideoEditing.videoType || "",
                            videoDuration: latestVideoEditing.duration || "",
                            editingRequirements: latestVideoEditing.requirements || "",
                            deadline: latestVideoEditing.deadline || "",
                            videoEditingComments: latestVideoEditing.comments || ""
                        }));
                    }

                    if (leadData.graphicDesignHistory?.length > 0) {
                        const latestGraphicDesign = leadData.graphicDesignHistory[leadData.graphicDesignHistory.length - 1];
                        setServiceData(prev => ({
                            ...prev,
                            graphicDesignId: latestGraphicDesign._id,
                            designType: latestGraphicDesign.designType || "",
                            designPurpose: latestGraphicDesign.designPurpose || "",
                            designDimensions: latestGraphicDesign.dimensions || "",
                            designDeadline: latestGraphicDesign.deadline || "",
                            designRequirements: latestGraphicDesign.requirements || "",
                            designComments: latestGraphicDesign.comments || ""
                        }));
                    }

                    // Set selected services based on what exists in the history
                    const services = [];
                    if (leadData.websiteDesigningHistory && leadData.websiteDesigningHistory.length > 0) {
                        services.push("WebSite Designing");
                    }
                    if (leadData.socialMediaHistory && leadData.socialMediaHistory.length > 0) {
                        services.push("Social Media");
                    }
                    if (leadData.seoHistory && leadData.seoHistory.length > 0) {
                        services.push("SEO");
                    }
                    if (leadData.contentCreationHistory?.length > 0) services.push("Content Creation");
                    if (leadData.cameraHistory?.length > 0) services.push("Camera Man");
                    if (leadData.videoEditingHistory?.length > 0) services.push("Video Editing");
                    if (leadData.graphicDesignHistory?.length > 0) services.push("Graphic Designing");
                    setSelectedServices(services);

                }
            } catch (error) {
                console.error("Error fetching lead details:", error);
                toast.error(`Failed to load lead details ${error ? error : ''}`);
            }
        };
        getAllUsers();
        fetchLeadDetails();
    }, [id, sessionToken, getAllUsers]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleServiceChange = (e) => {
        const { name, value } = e.target;
        setServiceData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleServiceSelect = (e) => {
        const selectedValues = e.target.value;
        setSelectedServices(selectedValues);
        setFormData(prev => ({
            ...prev,
            serviceName: selectedValues
        }));
        getAllUsers(selectedValues);
    };

    const handleSubmit = async (service) => {
        debugger;
        console.log("Service:", service);

        try {
            // Common payload properties
            const commonPayload = {
                comments: serviceData.comments || '',
                amount: serviceData.paidAmount || 0,
                paymentStatus: serviceData.paymentStatus || 'Pending'
            };

            if (service === "SEO" && serviceData.seoId) {
                const seoPayload = {
                    seoType: serviceData.seoType || [],
                    businessProfileAvailability: serviceData.businessProfileAvailability || '',
                    websiteAvailability: serviceData.websiteAvailability || '',
                    websiteDuration: serviceData.websiteDuration || '',
                    businessProfileDuration: serviceData.businessProfileDuration || '',
                    targetLocation: serviceData.targetLocation || [],
                    targetKeywords: serviceData.targetKeywords || [],
                    backlinkStatus: serviceData.backlinkStatus || '',
                    seoPackageType: serviceData.seoPackageType || '',
                    seoAssignedTo: serviceData.seoAssignedTo || '',
                    ...commonPayload
                };

                const response = await patchData(`seo/seo/${serviceData.seoId}`, seoPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("SEO details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update SEO details");
                }
            }
            else if (service === "WebSite Designing" && serviceData.websiteId) {
                const websitePayload = {
                    websiteType: serviceData.websiteType || "",
                    totalPages: serviceData.totalPages || 0,
                    completedPages: serviceData.completedPages || 0,
                    requirements: serviceData.requirements || "",
                    deadline: serviceData.deadline || "",
                    assignedTo: serviceData.assignedTo || "",
                    websiteSchema: serviceData.websiteSchema || [],
                    hostingProvider: serviceData.hostingProvider || "",
                    hostingRenewalDate: serviceData.hostingRenewalDate || "",
                    domainProvider: serviceData.domainProvider || "",
                    domainRenewalDate: serviceData.domainRenewalDate || "",
                    hostingCost: serviceData.hostingCost || "",
                    domainCost: serviceData.domainCost || "",
                    maintenanceType: serviceData.maintenanceType || "",
                    ...commonPayload
                };

                const response = await patchData(`website/website/${serviceData.websiteId}`, websitePayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Website details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Website details");
                }
            }
            else if (service === "Social Media" && serviceData.socialMediaId) {
                const socialMediaPayload = {
                    platform: serviceData.platform || [],
                    postType: serviceData.postType || [],
                    contentTopic: serviceData.contentTopic || "",
                    postCaption: serviceData.postCaption || "",
                    hashtagsUsed: serviceData.hashtagsUsed || [],
                    scheduledDateTime: serviceData.scheduledDateTime || "",
                    postStatus: serviceData.postStatus || "",
                    totalPosts: serviceData.totalPosts || 0,
                    monthlyPosts: serviceData.monthlyPosts || 0,
                    completedPosts: serviceData.completedPosts || 0,
                    assignedTo: serviceData.assignedTo || "",
                    deadline: serviceData.deadline || "",
                    ...commonPayload
                };

                const response = await patchData(`socialmedia/socialmedia/${serviceData.socialMediaId}`, socialMediaPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Social Media details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Social Media details");
                }
            }
            else if (service === "Graphic Designing" && serviceData.graphicDesignId) {
                const graphicDesignPayload = {
                    designType: serviceData.designType || "",
                    designPurpose: serviceData.designPurpose || "",
                    designDimensions: serviceData.dimensions || "",
                    requirements: serviceData.graphicRequirements || "",
                    assignedTo: serviceData.assignedDesigner || "",
                    deadline: serviceData.graphicDeadline || "",
                    totalDesigns: serviceData.graphicTotalDesigns || 0,
                    completedDesigns: serviceData.completedDesigns || 0,
                    ...commonPayload
                };

                const response = await patchData(`graphic/graphic/${serviceData.graphicDesignId}`, graphicDesignPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Graphic Design details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Graphic Design details");
                }
            }
            else if (service === "Content Creation" && serviceData.contentCreationId) {
                const contentCreationPayload = {
                    contentType: serviceData.contentType || "",
                    contentTopic: serviceData.contentTopic || "",
                    targetAudience: serviceData.targetAudience || "",
                    keywords: serviceData.keywords || "",
                    seoFocus: serviceData.seoFocus || "",
                    wordCount: serviceData.wordCount || 0,
                    assignedTo: serviceData.assignedWriter || "",
                    deadline: serviceData.contentCreationDeadline || "",
                    totalTasks: serviceData.contentTotalTasks || 0,
                    completedTasks: serviceData.completedTasks || 0,
                    ...commonPayload
                };

                const response = await patchData(`content/content/${serviceData.contentCreationId}`, contentCreationPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Content Creation details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Content Creation details");
                }
            }
            else if (service === "Camera Man" && serviceData.cameraId) {
                const cameraPayload = {
                    shootType: serviceData.shootType || "",
                    shootLocation: serviceData.location || "",
                    shootDate: serviceData.cameraScheduledDateTime || "",
                    duration: serviceData.duration || "",
                    requirements: serviceData.clientGuidelines || "",
                    assignedTo: serviceData.assignedPhotographer || "",
                    shotList: serviceData.shotList || [],
                    totalShots: serviceData.totalShots || 0,
                    completedShots: serviceData.completedShots || 0,
                    ...commonPayload
                };

                const response = await patchData(`camera/camera/${serviceData.cameraId}`, cameraPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Camera Service details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Camera Service details");
                }
            }
            else if (service === "Video Editing" && serviceData.videoEditingId) {
                const videoEditingPayload = {
                    videoDuration: serviceData.duration || "",
                    requirements: serviceData.editingRequirements || "",
                    assignedTo: serviceData.assignedEditor || "",
                    deadline: serviceData.editingDeadline || "",
                    editingSoftwareUsed: serviceData.editingSoftwareUsed || "",
                    totalVideos: serviceData.totalVideos || 0,
                    completedVideos: serviceData.completedVideos || 0,
                    ...commonPayload
                };

                const response = await patchData(`video/video/${serviceData.videoEditingId}`, videoEditingPayload, sessionToken);
                if (response.status === 200) {
                    toast.success("Video Editing details updated successfully!");
                } else {
                    throw new Error(response.message || "Failed to update Video Editing details");
                }
            }
            else {
                console.warn("Invalid service or missing ID");
                toast.warning("Please select a valid service to update");
            }
            setIsEditMode(false);
        } catch (error) {
            console.error("Error updating service:", error);
            toast.error(`${error ? error : ''}` || "Failed to update service details");
        }
    };


    const getServiceFields = (service) => {
        const serviceFieldsMap = {
            "Video Editing": [
                "projectName", "assignedEditor", "editingSoftwareUsed",
                "deadline", "comments", "paidAmount", "paymentStatus"
            ],
            "WebSite Designing": [
                "websiteType", "totalPages", "duration", "requirements",
                "websiteSchema", "hostingProvider", "hostingRenewalDate", "domainProvider",
                "domainRenewalDate", "maintenanceType", "assignedTo", "comments",
                "deadline", "paidAmount", "paymentStatus"
            ],
            "SEO": [
                "seoType", "businessProfileAvailability", "websiteAvailability", "websiteDuration",
                "businessProfileDuration", "targetLocation", "targetKeywords",
                "backlinkStatus", "seoPackageType", "seoAssignedTo",
                "amount", "paidAmount", "paymentStatus"
            ],
            "Social Media": [
                "platform", "postType", "contentTopic", "postCaption", "hashtagsUsed",
                "totalPosts", "monthlyPosts", "scheduledDateTime", "assignedTo",
                "deadline", "comments", "paidAmount",
                "paymentStatus"
            ],
            "Graphic Designing": [
                "projectName", "designType", "requirements", "assignedDesigner",
                "deadline", "totalDesigns", "comments",
                "paidAmount", "paymentStatus"
            ],
            "Content Creation": [
                "projectName", "contentType", "targetAudience", "keywords",
                "seoFocus", "wordCount", "assignedWriter", "deadline",
                "totalTasks", "comments", "paidAmount",
                "paymentStatus"
            ],
            "Camera Man": [
                "projectName", "shootType", "location", "scheduledDateTime",
                "assignedPhotographer", "shotList", "totalShots", "clientGuidelines",
                "deadline", "comments", "paidAmount", "paymentStatus"
            ]
        };

        return serviceFieldsMap[service] || [];
    };

    const renderViewField = (label, value) => {
        return (
            <Grid item xs={4}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{label}</Typography>
                <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                    {value || '-'}
                </Typography>
            </Grid>
        );
    };

    const renderBasicInfoSteps = () => {
        if (isEditMode) {
            return (
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <TextField
                                margin="dense"
                                select
                                label="General Status"
                                name="generalStatus"
                                value={formData.generalStatus}
                                onChange={handleInputChange}
                                fullWidth
                            >
                                <MenuItem value="Interested">Interested</MenuItem>
                                <MenuItem value="Not Interested">Not Interested</MenuItem>
                                <MenuItem value="Follow-up Needed">Follow-up Needed</MenuItem>
                                <MenuItem value="Converted">Converted</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Service Type</InputLabel>
                                <Select
                                    multiple
                                    name="serviceName"
                                    value={selectedServices}
                                    onChange={handleServiceSelect}
                                    renderValue={(selected) => selected.join(", ")}
                                >
                                    {serviceOptions.map((service) => (
                                        <MenuItem key={service} value={service}>
                                            <Checkbox checked={selectedServices.includes(service)} />
                                            <Typography>{service}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Assigned Users</InputLabel>
                                <Select
                                    multiple
                                    name="assignedTo"
                                    value={Array.isArray(formData.assignedTo) ? formData.assignedTo : []}
                                    onChange={(e) => {
                                        const selectedValues = e.target.value;
                                        setFormData(prev => ({
                                            ...prev,
                                            assignedTo: Array.isArray(selectedValues) ? selectedValues : [selectedValues]
                                        }));
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected || selected.length === 0) return <em>No users selected</em>;
                                        return selected.map(userId => {
                                            const user = users.find(u => u._id === userId);
                                            return user ? user.name : "";
                                        }).join(", ");
                                    }}
                                >
                                    {users.map((user) => (
                                        <MenuItem key={user._id} value={user._id}>
                                            <Checkbox checked={formData.assignedTo?.includes(user._id) || false} />
                                            <Typography>{`${user.name} (${user.role} - ${user.roleType})`}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </>
            );
        } else {
            return (
                <>
                    <Grid container spacing={2}>
                        {/* {renderViewField("General Status", formData.generalStatus)} */}
                        {renderViewField("Service Type", selectedServices.join(", "))}
                        {/* {renderViewField("Assigned Users",
                            formData.assignedTo?.map(userId => {
                                const user = users.find(u => u._id === userId);
                                return user ? user.name : "";
                            }).join(", ") || 'N/A'
                        )}
                        {renderViewField("Start Date", formData.startDate)}
                        {renderViewField("Duration", formData.duration)}
                        {renderViewField("Call History", formData.callHistory)}
                        {renderViewField("Requirements", formData.requirements)}
                        {renderViewField("Progress", `${formData.progress}%`)} */}
                    </Grid>
                </>
            );
        }
    };

    const renderServiceStep = (service) => {
        const serviceTeamLeaders = users.filter(user => user.serviceTeamType === service);
        if (isEditMode) {
            switch (service) {
                case "Content Creation":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Project Name" name="contentProjectName" value={serviceData.contentProjectName || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Content Type" name="contentType" value={serviceData.contentType || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Target Audience" name="targetAudience" value={serviceData.targetAudience || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Keywords" name="keywords" value={serviceData.keywords || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="SEO Focus" name="seoFocus" value={serviceData.seoFocus || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" type="number" label="Word Count" name="wordCount" value={serviceData.wordCount || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned Writer</InputLabel>
                                        <Select
                                            name="assignedWriter"
                                            value={serviceData.assignedWriter || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned Writer"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="contentCreationDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.contentCreationDeadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" type="number" label="Total Tasks" name="contentTotalTasks" value={serviceData.contentTotalTasks || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="contentComments" value={serviceData.contentComments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="contentCreationPaidAmount"
                                        value={serviceData.contentCreationPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="ccPaymentStatus" value={serviceData.ccPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                case "Camera Man":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Project Name" name="cameraProjectName" value={serviceData.cameraProjectName || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Shoot Type" name="shootType" value={serviceData.shootType || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Location" name="location" value={serviceData.location || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Scheduled Date Time" name="cameraScheduledDateTime" type="datetime-local" InputLabelProps={{ shrink: true }} value={serviceData.cameraScheduledDateTime || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned Photographer</InputLabel>
                                        <Select
                                            name="assignedPhotographer"
                                            value={serviceData.assignedPhotographer || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned Photographer"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Shot List" name="shotList" value={(serviceData.shotList || []).map(s => s.shotName).join('\n')} onChange={(e) => {
                                        const shotArray = e.target.value.split('\n').map((line) => ({
                                            shotName: line.trim(),
                                            completed: false
                                        })).filter(item => item.shotName);
                                        setServiceData(prev => ({
                                            ...prev,
                                            shotList: shotArray
                                        }));
                                    }} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Client Guidelines" name="clientGuidelines" value={serviceData.clientGuidelines || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="cameraDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.cameraDeadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="cameraComments" value={serviceData.cameraComments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        label="Total Videos"
                                        name="totalShots"
                                        type="number"
                                        value={serviceData.totalShots || ''}
                                        onChange={handleServiceChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="cameraPaidAmount"
                                        value={serviceData.cameraPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="cameraPaymentStatus" value={serviceData.cameraPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                case "Video Editing":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Project Name" name="editingProjectName" value={serviceData.editingProjectName || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned Editor</InputLabel>
                                        <Select
                                            name="assignedEditor"
                                            value={serviceData.assignedEditor || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned Editor"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Editing Software Used" name="editingSoftwareUsed" value={serviceData.editingSoftwareUsed || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        label="Total Tasks"
                                        name="totalEditingShots"
                                        type="number"
                                        value={serviceData.totalEditingShots || ''}
                                        onChange={handleServiceChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="editingDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.editingDeadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="editingComments" value={serviceData.editingComments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="editingPaidAmount"
                                        value={serviceData.editingPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="editingPaymentStatus" value={serviceData.editingPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                case "Social Media":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        select
                                        label="Platform"
                                        name="platform"
                                        value={serviceData.platform || []}
                                        onChange={handleServiceChange}
                                        fullWidth
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                        }}
                                    >
                                        {["Facebook", "Instagram", "Twitter", "LinkedIn", "YouTube", "TikTok"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        select
                                        label="Post Type"
                                        name="postType"
                                        value={serviceData.postType || []}
                                        onChange={handleServiceChange}
                                        fullWidth
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                        }}
                                    >
                                        {["Image", "Video", "Text", "Story", "Reel", "Ad"].map(type => (
                                            <MenuItem key={type} value={type}>{type}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        label="Total Posts"
                                        name="totalPosts"
                                        type="number"
                                        value={serviceData.totalPosts || ''}
                                        onChange={handleServiceChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        label="No of Reels / Months"
                                        name="monthlyPosts"
                                        type="number"
                                        value={serviceData.monthlyPosts || ''}
                                        onChange={handleServiceChange}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Content Topic" name="contentTopic" value={serviceData.contentTopic || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Post Caption" name="postCaption" value={serviceData.postCaption || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Scheduled Date Time" name="scheduledDateTime" type="datetime-local" InputLabelProps={{ shrink: true }} value={serviceData.scheduledDateTime || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned To</InputLabel>
                                        <Select
                                            name="assignedTo"
                                            value={serviceData.assignedTo || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned To"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="socialMediaDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.socialMediaDeadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="socialMediaComments" value={serviceData.socialMediaComments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="socialMediaPaidAmount"
                                        value={serviceData.socialMediaPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="socialPaymentStatus" value={serviceData.socialPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                case "WebSite Designing":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Website Type" name="websiteType" value={serviceData.websiteType || ''} onChange={handleServiceChange} fullWidth>
                                        <MenuItem value="E-Commerce">E-Commerce</MenuItem>
                                        <MenuItem value="Normal">Normal</MenuItem>
                                        <MenuItem value="Single-Landing-Page">Single-Landing-Page</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" type='number' label="Total Pages" name="totalPages" value={serviceData.totalPages || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned Users</InputLabel>
                                        <Select
                                            multiple
                                            name="assignedTo"
                                            value={Array.isArray(serviceData.assignedTo) ? serviceData.assignedTo : []}
                                            onChange={(e) => {
                                                const selectedValues = e.target.value;
                                                setServiceData(prev => ({
                                                    ...prev,
                                                    assignedTo: Array.isArray(selectedValues) ? selectedValues : [selectedValues]
                                                }));
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected || selected.length === 0) return <em>No users selected</em>;
                                                return selected.map(userId => {
                                                    const user = users.find(u => u._id === userId);
                                                    return user ? user.name : "";
                                                }).join(", ");
                                            }}
                                        >
                                            {users.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    <Checkbox checked={formData.assignedTo?.includes(user._id) || false} />
                                                    <Typography>{`${user.name} (${user.serviceTeamType || 'No Service'})`}</Typography>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="comments" value={serviceData.comments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="deadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.deadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="paidAmount"
                                        value={serviceData.paidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="paymentStatus" value={serviceData.paymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        select
                                        label="Domain & Maintenance"
                                        name="websiteSchema"
                                        value={serviceData.websiteSchema || []}
                                        onChange={handleServiceChange}
                                        fullWidth
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                        }}
                                    >
                                        <MenuItem value="Hosting">Hosting</MenuItem>
                                        <MenuItem value="Domain">Domain</MenuItem>
                                        <MenuItem value="Website Maintenance">Website Maintenance</MenuItem>
                                    </TextField>
                                </Grid>
                                {(serviceData.websiteSchema?.includes("Hosting")) && (
                                    <>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth margin="dense">
                                                <InputLabel>Hosting Provider</InputLabel>
                                                <Select
                                                    name="hostingProvider"
                                                    value={serviceData.hostingProvider || ''}
                                                    onChange={handleServiceChange}
                                                    label="Hosting Provider"
                                                >
                                                    <MenuItem value="Self">Self (Our Company)</MenuItem>
                                                    <MenuItem value="Client">Client Side</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                margin="dense"
                                                label="Hosting Renewal Date"
                                                name="hostingRenewalDate"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                value={serviceData.hostingRenewalDate || ''}
                                                onChange={handleServiceChange}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                margin="dense"
                                                label="Hosting Cost"
                                                name="hostingCost"
                                                InputLabelProps={{ shrink: true }}
                                                value={serviceData.hostingCost || ''}
                                                onChange={handleServiceChange}
                                                fullWidth
                                            />
                                        </Grid>
                                    </>
                                )}
                                {(serviceData.websiteSchema?.includes("Domain")) && (
                                    <>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth margin="dense">
                                                <InputLabel>Domain Provider</InputLabel>
                                                <Select
                                                    name="domainProvider"
                                                    value={serviceData.domainProvider || ''}
                                                    onChange={handleServiceChange}
                                                    label="Domain Provider"
                                                >
                                                    <MenuItem value="Self">Self (Our Company)</MenuItem>
                                                    <MenuItem value="Client">Client Side</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                margin="dense"
                                                label="Domain Renewal Date"
                                                name="domainRenewalDate"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                value={serviceData.domainRenewalDate || ''}
                                                onChange={handleServiceChange}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                margin="dense"
                                                label="Domain Cost"
                                                name="domainCost"
                                                InputLabelProps={{ shrink: true }}
                                                value={serviceData.domainCost || ''}
                                                onChange={handleServiceChange}
                                                fullWidth
                                            />
                                        </Grid>
                                    </>
                                )}

                                {serviceData.websiteSchema?.includes("Website Maintenance") && (
                                    <Grid item xs={4}>
                                        <FormControl fullWidth margin="dense">
                                            <InputLabel>Maintenance Type</InputLabel>
                                            <Select
                                                name="maintenanceType"
                                                value={serviceData.maintenanceType || ''}
                                                onChange={handleServiceChange}
                                                label="Maintenance Type"
                                            >
                                                <MenuItem value="Included">Included</MenuItem>
                                                <MenuItem value="Excluded">Excluded</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                            </Grid>
                        </>
                    );
                case "Graphic Designing":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Project Name" name="graphicProjectName" value={serviceData.graphicProjectName || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Design Type" name="designType" value={serviceData.designType || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Requirements" name="graphicRequirements" value={serviceData.graphicRequirements || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned Designer</InputLabel>
                                        <Select
                                            name="assignedDesigner"
                                            value={serviceData.assignedDesigner || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned Designer"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Deadline" name="graphicDeadline" type="date" InputLabelProps={{ shrink: true }} value={serviceData.graphicDeadline || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" type='number' label="Total Designs" name="graphicTotalDesigns" value={serviceData.graphicTotalDesigns || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Comments" name="graphicComments" value={serviceData.graphicComments || ''} onChange={handleServiceChange} fullWidth multiline />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="graphicPaidAmount"
                                        value={serviceData.graphicPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="graphicPaymentStatus" value={serviceData.graphicPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                case "SEO":
                    return (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <TextField
                                        margin="dense"
                                        select
                                        label="SEO Type"
                                        name="seoType"
                                        value={serviceData.seoType || []}
                                        onChange={handleServiceChange}
                                        fullWidth
                                        SelectProps={{
                                            multiple: true,
                                            renderValue: (selected) => Array.isArray(selected) ? selected.join(', ') : ''
                                        }}
                                    >
                                        <MenuItem value="Google Business Profile">Google Business Profile</MenuItem>
                                        <MenuItem value="Website SEO">Website SEO</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Business Profile Availability" name="businessProfileAvailability" value={serviceData.businessProfileAvailability || ''} onChange={handleServiceChange} fullWidth>
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Website Availability" name="websiteAvailability" value={serviceData.websiteAvailability || ''} onChange={handleServiceChange} fullWidth>
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Website SEO Duration" name="websiteDuration" type="date" InputLabelProps={{ shrink: true }} value={serviceData.websiteDuration || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Business Profile Duration" name="businessProfileDuration" type="date" InputLabelProps={{ shrink: true }} value={serviceData.businessProfileDuration || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Target Location" name="targetLocation" value={serviceData.targetLocation || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" label="Target Keywords" name="targetKeywords" value={serviceData.targetKeywords || ''} onChange={handleServiceChange} fullWidth />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Back Link Status" name="backlinkStatus" value={serviceData.backlinkStatus || ''} onChange={handleServiceChange} fullWidth>
                                        <MenuItem value="No Backlinks">No Backlinks</MenuItem>
                                        <MenuItem value="Low">Low</MenuItem>
                                        <MenuItem value="Moderate">Moderate</MenuItem>
                                        <MenuItem value="High">High</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Package Type" name="seoPackageType" value={serviceData.seoPackageType || ''} onChange={handleServiceChange} fullWidth>
                                        <MenuItem value="3 months">3 Months</MenuItem>
                                        <MenuItem value="6 months">6 Months</MenuItem>
                                        <MenuItem value="1 year">1 Year</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel>Assigned To</InputLabel>
                                        <Select
                                            name="seoAssignedTo"
                                            value={serviceData.seoAssignedTo || ''}
                                            onChange={handleServiceChange}
                                            label="Assigned To"
                                        >
                                            {serviceTeamLeaders.map((user) => (
                                                <MenuItem key={user._id} value={user._id}>
                                                    {user.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        margin='dense'
                                        label="Amount"
                                        name="seoPaidAmount"
                                        value={serviceData.seoPaidAmount || ''}
                                        onChange={handleServiceChange}
                                        type="number"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField margin="dense" select label="Payment Status" name="seoPaymentStatus" value={serviceData.seoPaymentStatus || ''} onChange={handleServiceChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </>
                    );
                default:
                    return null;
            }
        } else {
            // View mode for service steps
            const fields = getServiceFields(service);
            return (
                <Grid container spacing={2}>
                    {fields.map(field => (
                        renderViewField(
                            field.split(/(?=[A-Z])/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                            serviceData[field] || 'N/A'
                        )
                    ))}
                </Grid>
            );
        }
    };

    return (
        <div>
            <Helmet>
                <title>View Details</title>
            </Helmet>
            <Container>
                <Card sx={{ padding: 3, boxShadow: 3 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h6" gutterBottom>
                            {action} Lead
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                            <Button
                                variant='contained'
                                startIcon={<Iconify icon={isEditMode ? "" : "eva:edit-fill"} />}
                                onClick={() => {
                                    setAction(isEditMode ? 'View' : 'Edit');
                                    setIsEditMode(!isEditMode);
                                }}
                            >
                                {isEditMode ? 'Cancel' : 'Edit'}
                            </Button>
                            <Button
                                variant='contained'
                                startIcon={<Iconify icon="solar:history-3-bold" />}
                                onClick={() => setActiveStep(selectedServices.length + 1)}
                            >
                                History
                            </Button>
                        </Box>
                    </Stack>
                    <Stepper activeStep={activeStep} orientation="vertical" sx={{ mb: 4 }}>
                        <Step key="basic">
                            <StepLabel
                                onClick={() => setActiveStep(0)}
                                sx={{ cursor: 'pointer' }}
                            >
                                Basic Information
                            </StepLabel>
                            <StepContent>
                                {renderBasicInfoSteps({ editable: isEditMode && activeStep === 0 })}

                                {isEditMode && activeStep === 0 && (
                                    <Box sx={{ mt: 2 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            Save Changes
                                        </Button>
                                    </Box>
                                )}
                            </StepContent>
                        </Step>

                        {selectedServices.map((service, index) => (
                            <Step key={index}>
                                <StepLabel
                                    onClick={() => setActiveStep(index + 1)}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    {service}
                                </StepLabel>
                                <StepContent>
                                    {renderServiceStep(service, { editable: isEditMode && activeStep === index + 1 })}

                                    {isEditMode && activeStep === index + 1 && (
                                        <Box sx={{ mt: 2 }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleSubmit(service)}
                                            >
                                                Save Changes
                                            </Button>
                                        </Box>
                                    )}
                                </StepContent>
                            </Step>
                        ))}
                        <Step key="history">
                            <StepLabel onClick={() => setActiveStep(selectedServices.length + 1)} sx={{ cursor: 'pointer' }}>
                                History
                            </StepLabel>
                            <StepContent>
                                <Box mt={2}>
                                    <TableContainer>
                                        <Table outlined>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Assigned Username</TableCell>
                                                    <TableCell>Role</TableCell>
                                                    <TableCell>Role Type</TableCell>
                                                    <TableCell>Assigned At</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    history.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={5} align="center">
                                                                No History found
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        reversedHistory.map((item, index) => (
                                                            <TableRow>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{item?.assignedUserName}</TableCell>
                                                                <TableCell>{item?.assignedUserRole}</TableCell>
                                                                <TableCell>{item?.assignedUserType}</TableCell>
                                                                <TableCell>{new Date(item?.assignedAt).toLocaleString()}</TableCell>
                                                            </TableRow>
                                                        ))
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </StepContent>
                        </Step>
                    </Stepper>

                </Card>
            </Container>
        </div>
    )
}

export default ViewDetails